module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_concept_04-86c96de001bd73d388ae9eb0c89f5288.jpg";